import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./DataLastUpdates.styles";
import { HMICachedDataContext } from "contexts/HMICachedDataContext/HMICachedDataContext";
import { getDataLastUpdatedDate } from "utilities/utilities";

export const DataLastUpdated = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { store } = useContext(HMICachedDataContext);

    const dataLastUpdated = getDataLastUpdatedDate(store.lastUpdated!);

    return (
        <Box>
            <Typography variant="subtitle2" className={classes.title}>
                {t("HMI.data_last_updated").toUpperCase()} {dataLastUpdated}
            </Typography>
        </Box>
    );
};
